import { createFileRoute, redirect } from '@tanstack/react-router'

// Assinaturas virou um filtro de Organizações (a tabela era a mesma). A rota
// fica para links antigos.
export const Route = createFileRoute('/_app/assinaturas')({
  beforeLoad: () => {
    throw redirect({ to: '/organizacoes', replace: true })
  },
})
